import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import './ChatbotPage.css';

function ChatbotPage() {
  const [searchTerm, setSearchTerm] = useState('');
  useEffect(() => { document.title = 'PEC - Chatbot'; }, []);
  const [messageInput, setMessageInput] = useState('');
  const [messages, setMessages] = useState([
    {
      id: 1,
      type: 'bot',
      content: '¡Hola! Soy tu asistente AI. ¿En qué puedo ayudarte hoy?',
      timestamp: new Date()
    }
  ]);

  // Mock conversation stats
  const conversationStats = {
    totalMessages: 156,
    todayMessages: 23,
    averageResponseTime: '1.2s',
    helpfulResponses: '94%'
  };

  // Quick action prompts
  const quickPrompts = [
    { title: 'Resumen de Tareas', prompt: 'Resume mis tareas pendientes para hoy', icon: '✅' },
    { title: 'Análisis Financiero', prompt: 'Analiza mis gastos del mes actual', icon: '💰' },
    { title: 'Planificación', prompt: 'Ayúdame a planificar mi semana', icon: '📅' },
    { title: 'Productividad', prompt: 'Dame consejos para mejorar mi productividad', icon: '🚀' }
  ];

  const handleSendMessage = () => {
    if (!messageInput.trim()) return;

    const newMessage = {
      id: messages.length + 1,
      type: 'user',
      content: messageInput,
      timestamp: new Date()
    };

    setMessages([...messages, newMessage]);
    setMessageInput('');

    // Simulate AI response
    setTimeout(() => {
      const botResponse = {
        id: messages.length + 2,
        type: 'bot',
        content: 'Gracias por tu mensaje. Esta funcionalidad está en desarrollo y pronto podrás interactuar completamente con el asistente AI.',
        timestamp: new Date()
      };
      setMessages(prev => [...prev, botResponse]);
    }, 1000);
  };

  const handleQuickPrompt = (prompt) => {
    setMessageInput(prompt);
  };

  const formatTime = (timestamp) => {
    return timestamp.toLocaleTimeString('es-ES', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <div className="chatbot-page">
      <Header 
        currentPage="chatbot" 
        showSearch 
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        showAddButton 
        onAddNew={() => setMessages([{ id: Date.now(), type: 'bot', content: 'Nueva conversación iniciada.', timestamp: new Date() }])}
      />

      <div className="chatbot-content">
        {/* AI Stats */}
        <div className="chatbot-stats">
          <div className="stat-card total">
            <div className="stat-icon">💬</div>
            <div className="stat-content">
              <h3>{conversationStats.totalMessages}</h3>
              <p>Mensajes Totales</p>
            </div>
          </div>
          <div className="stat-card today">
            <div className="stat-icon">📅</div>
            <div className="stat-content">
              <h3>{conversationStats.todayMessages}</h3>
              <p>Mensajes Hoy</p>
            </div>
          </div>
          <div className="stat-card response">
            <div className="stat-icon">⚡</div>
            <div className="stat-content">
              <h3>{conversationStats.averageResponseTime}</h3>
              <p>Tiempo Respuesta</p>
            </div>
          </div>
          <div className="stat-card helpful">
            <div className="stat-icon">🎯</div>
            <div className="stat-content">
              <h3>{conversationStats.helpfulResponses}</h3>
              <p>Respuestas Útiles</p>
            </div>
          </div>
        </div>

        {/* Chat Interface */}
        <div className="chat-container">
          <div className="chat-messages">
            {messages.map((message) => (
              <div key={message.id} className={`message ${message.type}`}>
                <div className="message-content">
                  <div className="message-text">{message.content}</div>
                  <div className="message-time">{formatTime(message.timestamp)}</div>
                </div>
                <div className="message-avatar">
                  {message.type === 'bot' ? '🤖' : '👤'}
                </div>
              </div>
            ))}
          </div>

          <div className="chat-input-area">
            <div className="quick-prompts">
              {quickPrompts.map((prompt, index) => (
                <button
                  key={index}
                  className="quick-prompt-btn"
                  onClick={() => handleQuickPrompt(prompt.prompt)}
                  title={prompt.title}
                >
                  {prompt.icon} {prompt.title}
                </button>
              ))}
            </div>

            <div className="message-input-container">
              <input
                type="text"
                value={messageInput}
                onChange={(e) => setMessageInput(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
                placeholder="Escribe tu mensaje aquí..."
                className="message-input"
              />
              <button
                onClick={handleSendMessage}
                className="send-button"
                disabled={!messageInput.trim()}
              >
                ➤
              </button>
            </div>
          </div>
        </div>

        {/* AI Features */}
        <div className="ai-features-section">
          <h2>Capacidades del Asistente</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Análisis de Datos</h3>
              <p>Analiza tus tareas, finanzas y patrones de productividad</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📅</div>
              <h3>Planificación Inteligente</h3>
              <p>Ayuda a organizar tu tiempo y priorizar actividades</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💡</div>
              <h3>Sugerencias Personalizadas</h3>
              <p>Recomendaciones basadas en tus hábitos y objetivos</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔍</div>
              <h3>Búsqueda Inteligente</h3>
              <p>Encuentra información rápidamente en todas tus notas</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChatbotPage;
